import React, { Component } from "react";

class NoData extends Component {
  render() {
    return (
      <div className="noData">
        <div className="noDataTitle">Nothing to display yet!</div>
        <div className="noDataComment">
          <a href="/jobs">View writing jobs <i className="fe fe-arrow-right"></i></a>
        </div>
      </div>
    );
  }
}

export default NoData;



// WEBPACK FOOTER //
// ./src/components/utilities/jobsNoData.js